import doubtUseCase from "../../../../domain/usecase/impl/doubt/doubtUseCase";
import { ActionContext } from "vuex";
import { Doubt } from "../../../../domain/entities/doubt";

class DoubtState {
  doubts: Doubt[] = [];
}

const state = new DoubtState();

const mutations = {
  SET_DOUBTS(state: DoubtState, doubts: Doubt[]): void {
    state.doubts = doubts;
  }
};

const actions = {
  async create({commit}: ActionContext<DoubtState, DoubtState>, payload: {doubt: Doubt, courseID: number, contentID: number}): Promise<number> {
    return await doubtUseCase.create(payload.doubt, payload.courseID, payload.contentID);
  },

  async list({ commit }: ActionContext<DoubtState, DoubtState>,  payload: {courseID: number, contentID: number}): Promise<void> {
    const response: Doubt[] = await doubtUseCase.list(payload.courseID, payload.contentID);
    commit("SET_DOUBTS", response);
  },

};

const getters = {
  doubts: (state: DoubtState): Doubt[] => state.doubts || []
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
